import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgPowerOff = function SvgPowerOff(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M23.43 23.187a.933.933 0 000-1.358l-7.165-6.879 3.418-4.592a.464.464 0 00.036-.498.503.503 0 00-.443-.26H11.9l1.864-8.058a.475.475 0 00-.284-.544.513.513 0 00-.611.16l-4.57 6.144-6.316-6.063a1.03 1.03 0 00-1.402.012.933.933 0 00-.012 1.346l21.514 20.635c.388.335.983.316 1.348-.042v-.003zM6.454 10.262a.256.256 0 00-.38.03l-3.2 4.308a.464.464 0 00-.037.498c.085.16.257.26.444.26h7.376l-1.87 8.057a.475.475 0 00.285.542.507.507 0 00.607-.16l4.406-5.923a.232.232 0 00-.027-.309l-7.604-7.303z"
  }));
};

export default SvgPowerOff;